import { gql } from "graphql-request";

import { client } from "@krea/customer-features/graphql";
import { FIELD_REQUEST_FRAGMENT } from "@krea/customer-features/graphql/field-request/field-request.fragment";
import {
  COMPANY_LOAN_BID_FRAGMENT,
  INVOICE_PURCHASE_BID_FRAGMENT,
  LEASING_BID_FRAGMENT,
  REAL_ESTATE_LOAN_BID_FRAGMENT,
  REVOLVING_CREDIT_BID_FRAGMENT,
  SELECTED_LENDER_RESPONSE_FRAGMENT,
} from "@krea/customer-features/graphql/lender-response/lender-response.fragment";
import { ILenderResponse } from "@krea/customer-features/types/lenderResponse";

const LENDER_RESPONSE_GET_SELECTED_QUERY = gql`
  query LenderResponseGetSelected($loanApplicationId: int!) {
    loanApplication(loanApplicationId: $loanApplicationId) {
      selectedLenderResponse {
        id
        ...SelectedLenderResponseFragment
        invoicePurchaseBid {
          ...InvoicePurchaseBidFragment
        }
        bid {
          ...CompanyLoanBidFragment
        }
        realEstateBid {
          ...RealEstateLoanBidFragment
        }
        leasingBid {
          ...LeasingBidFragment
        }
        revolvingCreditBid {
          ...RevolvingCreditBidFragment
        }
        fieldRequests {
          ...FieldRequestFragment
        }
      }
    }
  }
  ${SELECTED_LENDER_RESPONSE_FRAGMENT}
  ${INVOICE_PURCHASE_BID_FRAGMENT}
  ${COMPANY_LOAN_BID_FRAGMENT}
  ${REAL_ESTATE_LOAN_BID_FRAGMENT}
  ${LEASING_BID_FRAGMENT}
  ${REVOLVING_CREDIT_BID_FRAGMENT}
  ${FIELD_REQUEST_FRAGMENT}
`;

export interface ILenderResponseGetSelectedQueryData {
  loanApplication: {
    selectedLenderResponse: ILenderResponse | null;
  };
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type ILenderResponseGetSelectedQueryVariables = {
  loanApplicationId: string;
};

export const lenderResponseGetSelectedQuery = async (
  variables: ILenderResponseGetSelectedQueryVariables,
) => {
  return await client.request<
    ILenderResponseGetSelectedQueryData,
    ILenderResponseGetSelectedQueryVariables
  >({
    document: LENDER_RESPONSE_GET_SELECTED_QUERY,
    variables,
  });
};
